import { useQuery } from '@tanstack/react-query'
import { getMeProfile } from '@/api/services/auth.service'
import type { MeData } from '@/types/api.types'
import { useAuthStore } from '@/stores/useAuthStore'

export const meQueryKey = ['me'] as const

const STALE_TIME_MS = 5 * 60 * 1000
const GC_TIME_MS = 10 * 60 * 1000

/**
 * Fetches the current user's full profile (GET /users/me). Used for permissions and UI access.
 */
export function useMe(): ReturnType<typeof useQuery<MeData>> {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  return useQuery<MeData>({
    queryKey: meQueryKey,
    queryFn: () => getMeProfile(),
    enabled: isAuthenticated,
    staleTime: STALE_TIME_MS,
    gcTime: GC_TIME_MS,
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  })
}
